import { render, staticRenderFns } from "./list.vue?vue&type=template&id=75860670&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=75860670&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=75860670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75860670",
  null
  
)

export default component.exports